<!-- start cursor -->
<div class="cursor-page-inner">
    <div class="circle-cursor circle-cursor-inner"></div>
    <div class="circle-cursor circle-cursor-outer"></div>
</div>
<!-- end cursor -->

<!-- Header -->
<app-header></app-header>

<!-- Hero Section -->
<app-hero id="home"></app-hero>

<!-- About Section -->
<app-about id="about"></app-about>

<!-- Benefits Section -->
<app-benefits></app-benefits>

<!-- Pricing Section -->
<app-pricing id="pricing"></app-pricing>

<!-- Counter Section 
<app-counter></app-counter> -->

<!-- Marquee Sections -->
<app-marquee></app-marquee>

<!-- Services Section -->
<app-services id="expertise"></app-services>

<!-- Products Section -->
<app-products></app-products>

<!-- Portfolio Section -->
<app-portfolio id="work"></app-portfolio>

<!-- Testimonials Section -->
<app-testimonials id="testimonial"></app-testimonials>

<!-- Awards Section 
<app-awards id="awards"></app-awards> -->

<!-- Footer -->
<app-footer id="contact"></app-footer>

<!-- Scroll Progress -->
<app-scroll-progress></app-scroll-progress>

